import analytics from "../analytics/analytics.js";
import { IMPLEMENTATION_ENDPOINTS } from "../constants/urls.js";
import { getHostName } from "../utils/getHostingApp.js";
import { getRequestHeaders } from "../utils/getRequestHeaders.js";
const IS_DEV = 'undefined' != typeof process && 'development' === process.env.NODE_ENV;
const IS_STORYBOOK = 'undefined' != typeof process && !!process.env.STORYBOOK_ENV;
const IS_CHROMATIC = 'undefined' != typeof window && !!/chromatic/.exec(location?.href);
const host = getHostName(IS_STORYBOOK, IS_CHROMATIC);
const IS_DEBUG = false;
const PERSONALIZED_GREETING_URL = `${host}/genai-svc/genai/personalization/get-personalized-greeting`;
const RETRIEVE_URL = `${host}/genai-svc/genai/chat/retrieve-prompts`;
const CHATBOT_FEATURES_URL = `${host}/genai-svc/genai/config/chatbot-features`;
const SPEECH_URL = `${host}/genai-svc/genai/speech`;
const SPEECH_TIMEOUT = 10000;
const TRANSCRIPTION_URL = `${host}/genai-svc/genai/audio/transcriptions`;
const TRANSCRIPTION_TIMEOUT = 10000;
const getServiceConfig = (viewType, isMobile, customerName = '', logAnalytics)=>{
    const sameForAll = {
        personalizedGreetingUrl: PERSONALIZED_GREETING_URL,
        retrieveUrl: RETRIEVE_URL,
        speechFetchRequestOptions: {
            url: SPEECH_URL,
            timeout: SPEECH_TIMEOUT
        },
        transcriptionFetchRequestOptions: {
            url: TRANSCRIPTION_URL,
            timeout: TRANSCRIPTION_TIMEOUT
        }
    };
    const serviceConfig = {
        LANDING: {
            customerName,
            debugMode: IS_DEV,
            fetchRequestOptions: {
                url: `${host}${IMPLEMENTATION_ENDPOINTS.LANDING}`,
                headers: getRequestHeaders(isMobile, {
                    'x-request-from': 'homePage'
                })
            },
            ga4ProductName: '',
            isDev: IS_DEV,
            requestFrom: 'homePage',
            returnJSONResponse: true,
            showLandingChat: true,
            viewType,
            ...sameForAll
        },
        CHECKOUT: {
            customerName,
            debugMode: IS_DEV,
            fetchRequestOptions: {
                url: `${host}${IMPLEMENTATION_ENDPOINTS.CHECKOUT}`,
                headers: getRequestHeaders(isMobile, {
                    'x-request-from': 'UC'
                })
            },
            ga4ProductName: '',
            isDev: IS_DEV,
            requestFrom: 'UC',
            returnJSONResponse: true,
            showLandingChat: false,
            viewType,
            ...sameForAll
        },
        DRIVE: {
            customerName,
            debugMode: IS_DEV,
            fetchRequestOptions: {
                url: `${host}${IMPLEMENTATION_ENDPOINTS.DRIVE}`,
                headers: getRequestHeaders(isMobile, {
                    'x-request-from': 'rcListingPage'
                })
            },
            ga4ProductName: 'car',
            isDev: IS_DEV,
            requestFrom: 'rcListingsPage',
            returnJSONResponse: true,
            showLandingChat: false,
            viewType,
            ...sameForAll
        },
        FLYDETAILS: {
            customerName,
            debugMode: IS_DEV,
            fetchRequestOptions: {
                url: `${host}${IMPLEMENTATION_ENDPOINTS.FLYDETAILS}`,
                headers: getRequestHeaders(isMobile, {
                    'x-request-from': 'productDetailPage'
                })
            },
            ga4ProductName: 'air',
            isDev: IS_DEV,
            requestFrom: 'productDetailPage',
            returnJSONResponse: true,
            showLandingChat: false,
            viewType,
            ...sameForAll
        },
        FLYLISTINGS: {
            customerName,
            debugMode: IS_DEV,
            fetchRequestOptions: {
                url: `${host}${IMPLEMENTATION_ENDPOINTS.FLYDETAILS}`,
                headers: getRequestHeaders(isMobile, {
                    'x-request-from': 'productListingPage'
                })
            },
            ga4ProductName: 'air',
            isDev: IS_DEV,
            requestFrom: 'productListingPage',
            returnJSONResponse: true,
            showLandingChat: false,
            viewType,
            ...sameForAll
        },
        ITINERARY: {
            customerName,
            debugMode: IS_DEV,
            fetchRequestOptions: {
                url: `${host}${IMPLEMENTATION_ENDPOINTS.ITINERARY}`,
                headers: getRequestHeaders(isMobile, {
                    'x-request-from': 'travel-itinerary'
                })
            },
            ga4ProductName: '',
            isDev: IS_DEV,
            requestFrom: 'travel-itinerary',
            showLandingChat: false,
            viewType,
            ...sameForAll
        },
        PORTAL: {
            customerName,
            debugMode: IS_DEV,
            ga4ProductName: '',
            isDev: IS_DEV,
            viewType,
            showLandingChat: false,
            returnJSONResponse: true,
            requestFrom: 'pennyPortalPage',
            fetchRequestOptions: {
                url: `${host}${IMPLEMENTATION_ENDPOINTS.PORTAL}`,
                headers: {
                    'x-request-from': 'pennyPortalPage',
                    'x-model-version': '4'
                }
            },
            ...sameForAll
        },
        STAYDETAILS: {
            customerName,
            debugMode: IS_DEV,
            ga4ProductName: 'hotel',
            isDev: IS_DEV,
            viewType,
            showLandingChat: false,
            requestFrom: 'hotelDetailPage',
            returnJSONResponse: true,
            fetchRequestOptions: {
                url: `${host}${IMPLEMENTATION_ENDPOINTS.STAYDETAILS}`,
                headers: getRequestHeaders(isMobile, {
                    'x-request-from': 'hotelDetailPage'
                })
            },
            ...sameForAll
        },
        STAYLISTINGS: {
            customerName,
            debugMode: IS_DEV,
            ga4ProductName: 'hotel',
            isDev: IS_DEV,
            viewType,
            showLandingChat: false,
            requestFrom: 'hotelListingPage',
            returnJSONResponse: true,
            fetchRequestOptions: {
                url: `${host}${IMPLEMENTATION_ENDPOINTS.STAYLISTINGS}`,
                headers: getRequestHeaders(isMobile, {
                    'x-request-from': 'hotelListingPage'
                })
            },
            ...sameForAll
        }
    };
    const config = serviceConfig[viewType];
    if (!config) throw new Error(`No service configuration found for viewType: ${viewType}. Add configuration to serviceConfig object in /react-components/penny-chat-bot/src/config/serviceConfig.ts. `);
    const resolvedConfig = {
        ...config,
        logAnalytics: {
            logCustomerCarePhoneNumberClicked: ()=>{},
            logCustomerCarePhoneNumberDisplayed: ()=>{},
            logChatInitialization: ()=>{
                analytics.fireGA4Event({
                    event: 'initiate_chat',
                    attributes: {
                        type: 'penny',
                        page_name: config.requestFrom,
                        product_name: config.ga4ProductName
                    }
                });
            },
            logFirstMessageSubmitted: (chatMessages)=>{
                if (chatMessages.filter((m)=>'user' === m.role && '' !== m.content).length <= 1) analytics.fireGA4Event({
                    event: 'begin_chat',
                    attributes: {
                        type: 'penny',
                        page_name: config.requestFrom,
                        product_name: config.ga4ProductName
                    }
                });
            },
            ...logAnalytics
        }
    };
    return resolvedConfig;
};
export { CHATBOT_FEATURES_URL, IS_CHROMATIC, IS_DEBUG, IS_DEV, IS_STORYBOOK, PERSONALIZED_GREETING_URL, RETRIEVE_URL, SPEECH_TIMEOUT, SPEECH_URL, TRANSCRIPTION_TIMEOUT, TRANSCRIPTION_URL, getServiceConfig };
